import { log } from "console";
import { Cookies } from "react-cookie";
import {
  ApproveMargePayload,
  CandidateListAgainstStatusPayload,
  GetSalaryDetailsForApprovalPayload,
  SalaryDetailsGivenForWaitingCandPayload,
  SendOfferMailToCandidatePayload,
  UserCreationFromOnbardongPayload,
} from "../../models/employeeModel";
import {
  AddCandidateService,
  CandidateApproveReject,
  CandidateEditService,
  CheckActionStatus,
  GetAllBankListService,
  GetAllBulkUploadCandiidateListService,
  GetAllCandidateService,
  GetAllEmployeeService,
  GetAllEventStausService,
  GetAllOrgsForReportingManagerService,
  GetAllRefferalService,
  GetAllReportingManagersService,
  GetEmployeeAllDetailsService,
  GetEmployeeViewService,
  ReportingManagerGet,
  getBulkUploadCandidateUpdated,
  EmployeeEditService,
  resetpasswordrequestService,
  ReportingManagerEditService,
  GetMyTeamService,
  GetEmployeeLocationsService,
  CreateEmployeeLocationService,
  DeleteEmployeeLocationService,
  GetEmployeeImagesService,
  AddEmployeeImagesService,
  DeleteEmployeeImagesService,
  GetMyDocumentService,
  DeleteMyDocumentService,
  ChangeReportingManagerService,
  UpdateSingleEmpSalaryService,
  CalculateSingleEmpSalaryService,
  CandidateListAgainstStatusService,
  SalaryGivenForCandidateService,
  SendOfferMailToCandidateService,
  GetSalaryDetailsForApprovalService,
  UserCreationFromOnboardingService,
  getAllTermConditionService,
  UpdateAttendancePlatformService,
  UpdateAutoAttendanceService,
  UpdateAttenFromAnyLocationService,
  GetCandidateBulkCreateListService,
  GetCandidateBulkCreateStatusService,
  EmployeeTransferService,
  GetEmployeeTransferRequestsService,
  searchNameService,
  EmployeeByOrgWithParentsService,
} from "../../services/employeeService";
import { DomainGetAllService } from "../../services/organizationService";
import { ApiCallErrorAction, BeginApiCallAction, StopLoadingAction } from "./apiStatusActions";
import { LogOutAction } from "./userAction";
import { getBulkUploadCandidate } from "../../services/employeeService";

export enum EmployeeActionTypes {
  Add_Candidate_Success_Action = "[EMPLOYEE] Add Candidate Success Action",
  Get_All_Event_Staus_Success_Action = "[EMPLOYEE] Get All Event Status Success Action",
  Get_All_Refferal_Success_Action = "[EMPLOYEE] Get All Refferal Success Action",
  Get_Employee_View_Success_Action = "[EMPLOYEE] Employee View Success Action",
  Get_Reporting_Manager_Success_Action = "[EMPLOYEE] Get Reporting Manager Success Action",
  Get_Reporting_Manager_Org_Success_Action = "[EMPLOYEE] Get Reporting Manager Org Success Action",
  Get_Reporting_Manager_Search_Success_Action = "[EMPLOYEE] Get Reporting Manager Search Success Action",
  Candidate_Approve_Success_Action = "[EMPLOYEE] Candidate Approve Success Action",
  Get_All_Candidate_Success_Action = "[EMPLOYEE] Get All Candidate Success Action",
  Get_Attendence_Salary_type_Success_Action = "[EMPLOYEE] Get Attendence Salary type Success Action",
  Get_All_Employee_Success_Action = "[EMPLOYEE] Get All Employee Success Action",
  Get_Action_Status_Success_Action = "[EMPLOYEE] Get Action Status Success Action",
  Get_Employee_All_Details_Success_Action = "[EMPLOYEE] Get Employee All Details Success Action",
  Get_All_Bank_Success_Action = "[EMPLOYEE] Get All Bank Success Action",
  Edit_Candidate_Success_Action = "[EMPLOYEE] Candidate Edit Success Action",
  Candidate_Bulk_Upload_List_Success_Action = "[EMPLOYEE] Candidate Bulk Upload List Success Action",
  GET_BULK_UPLOAD_STATUS_ACTION = "[CUSTOMER] GET BULK UPLOAD STATUS ACTION",
  GET_BULK_UPLOAD_STATUS_ACTION_UPDATED = "[CUSTOMER] GET BULK UPLOAD STATUS ACTION UPDATED",
  Edit_Employee_Dashboard_Success_Action = "[EMPLOYEE] Employee Dashboard Edit Success Action",
  Reporting_Manager_Success_Action = "[EMPLOYEE] Reporting Manager Success Action",
  GET_All_Employee_WITH_PDF = "GET_All_Employee_WITH_PDF",
  Get_My_Team_List_Success_Action = "[EMPLOYEE] GET_MY_TEAM_SUCCESS",
  Get_Employee_Locations_Success_Action = "[EMPLOYEE] GET_EMPLOYEE_LOCATIONS_SUCCESS",
  Create_Employee_Locations_Success_Action = "[EMPLOYEE] CREATE_EMPLOYEE_LOCATIONS_SUCCESS",
  Delete_Employee_Locations_Success_Action = "[EMPLOYEE] DELETE_EMPLOYEE_LOCATIONS_SUCCESS",
  Add_Employee_Images_Success_Action = "[EMPLOYEE] Add Employee Images Success Action",
  Get_Employee_Images_Success_Action = "[EMPLOYEE] Get Employee Images Success Action",
  Delete_Employee_Images_Success_Action = "[EMPLOYEE] Delete Employee Images Success Action",
  Get_My_Document_Success_Action = "[EMPLOYEE] Get my document success action ",
  Delete_My_Document_Success_Action = "[EMPLOYEE] Delete my document success action",
  Change_Reporting_Manager_Success_Action = "[EMPLOYEE] Change reporting manger success action",
  Calculate_Employee_Single_Salary_Success_Action = "[EMPLOYEE] Calculate Single Employee Salary success action",
  Candidate_List_Against_Status_Success_Action = "[EMPLOYEE] Candidate List Against Status success action",
  Salary_Given_For_Waiting_Candidate_Success_Action = "[EMPLOYEE] Salary Given For Waiting Candidate success action",
  Get_Salary_Details_For_Candidate_Success_Action = "[EMPLOYEE] Get Salary Details For Candidate success action",
  Send_Official_Mail_To_Candidate_Success_Action = "[EMPLOYEE] Send Official Mail To Candidate success action",
  User_Creation_From_Onboarding_Candidate_Success_Action = "[EMPLOYEE] User Creation From Onboarding Candidate success action",
  Update_Salary_Structure_Success_Action = "[EMPLOYEE] Update Salary Structure success action",
  Get_All_Term_Conditions_Success_Action = "[EMPLOYEE] Get All Term Conditions success action",
  Employee_Transfer_Success_Action = "[EMPLOYEE] Employee Transfer Success Action",
  Get_Employee_Transfer_Requests_Success_Action = "[EMPLOYEE] Get Employee Transfer Requests Success Action",
  Update_Attendance_Platform_Success_Action = "[EMPLOYEE] Update Attendance Platform Success Action",
  Update_Auto_Attendance_Success_Action = "[EMPLOYEE] Update Auto Attendance Success Action",
  Update_Atten_From_Any_Location_Success_Action = "[EMPLOYEE] Update Atten From Any Location Success Action",
  Search_By_Name_Or_Id_Action = "[EMPLOYEE] Search By Name Or Id Action",
}

export const CreateCandidateAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Creating New Candidate. Please Wait...",
        type: 2,
      }),
    );
    return AddCandidateService(payload.data)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          payload.navigateTo("/employment/employee-list/");
          payload.enqueueSnackbar("Successfully Created", {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
          dispatch(CreateCandidateSuccessAction());
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const CreateCandidateSuccessAction = () => {
  return { type: EmployeeActionTypes.Add_Candidate_Success_Action };
};

export const GetAllEventStausAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "All Event Status List. Please Wait...",
        type: 2,
      }),
    );
    return GetAllEventStausService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(
            GetAllEventStausSuccessAction({
              req: response.data.request_data,
              filter: response.data.filter,
            }),
          );
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error?.response?.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message:
                error?.response?.data?.message ||
                "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const GetAllEventStausSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Get_All_Event_Staus_Success_Action,
    payload: data,
  };
};

export const getAllRefferalAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Get All Refferal. Please Wait...",
        type: 2,
      }),
    );
    return GetAllRefferalService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(
            GetAllRefferalSuccessAction({
              list: response.data.refferal_list,
              count: response.data.refferal_count,
            }),
          );
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const GetAllRefferalSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Get_All_Refferal_Success_Action,
    payload: data,
  };
};

export const GetEmployeeViewAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: " Please Wait...",
        type: 2,
      }),
    );
    return GetEmployeeViewService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          // payload.navigateTo("/organization/setup-department");
          // payload.enqueueSnackbar("List Successfully Created", {
          //   variant: "success",
          //   anchorOrigin: {
          //     vertical: "top",
          //     horizontal: "right",
          //   },
          // });
          dispatch(GetEmployeeViewSuccessAction(response.data));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const GetEmployeeViewSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Get_Employee_View_Success_Action,
    payload: data,
  };
};

export const getReportingManagerList = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: " Please Wait...",
        type: 2,
      }),
    );
    return ReportingManagerGet(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(getReportingManagerListSuccessAction(response.data));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const getReportingManagerListSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Get_Reporting_Manager_Success_Action,
    payload: data,
  };
};

// Debounced-search variant of the reporting-manager candidate list: same
// payload as employeebyproject plus an optional searchText and pagination
// (pageIndex/pageSize). Fires no global loader — it runs on every keystroke.
// Reuses the ReportingManagerList key. Resolves with { list, pagination } so
// callers (e.g. useReportingManagerSearch) can accumulate pages.
export const EmployeeByOrgWithParentsAction = (payload: {
  organization_id?: number;
  searchText?: string;
  pageIndex?: number;
  pageSize?: number;
}) => {
  return (dispatch: any, getState: any) => {
    return EmployeeByOrgWithParentsService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
          return null;
        } else {
          const body = response.data;
          const list = Array.isArray(body)
            ? body
            : body?.data ?? body?.rows ?? body?.list ?? [];
          dispatch(getReportingManagerListSuccessAction(list));
          return { list, pagination: body?.pagination ?? null };
        }
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        }
        return null;
      });
  };
};

export const GetAllOrgsForReportingManagerAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: " Please Wait...",
        type: 2,
      }),
    );
    return GetAllOrgsForReportingManagerService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(
            GetAllOrgsForReportingManagerSuccessAction(response.data?.data || [])
          );
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const GetAllOrgsForReportingManagerSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Get_Reporting_Manager_Org_Success_Action,
    payload: data,
  };
};

export const SearchReportingManagersAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    return GetAllReportingManagersService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(
            SearchReportingManagersSuccessAction(response.data?.data || [])
          );
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const SearchReportingManagersSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Get_Reporting_Manager_Search_Success_Action,
    payload: data,
  };
};

export const CandidateApproveAction = (payload: ApproveMargePayload) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: " Please Wait...",
        type: 2,
      }),
    );
    return CandidateApproveReject(payload.ApproveRejectPayload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(CandidateApproveSuccessAction());
          dispatch(GetAllEventStausAction(payload.EventStatusPayload));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const CandidateApproveSuccessAction = () => {
  return {
    type: EmployeeActionTypes.Candidate_Approve_Success_Action,
  };
};

export const getAllCandidateAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Get All Candidate. Please Wait...",
        type: 2,
      }),
    );
    return GetAllCandidateService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(
            GetAllCandidateSuccessAction({
              list: response.data.candidate_list,
              count: response.data.candidate_count,
            }),
          );
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const GetAllCandidateSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Get_All_Candidate_Success_Action,
    payload: data,
  };
};

export const GetAttendenceSalarytypeAction = () => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Get All Salary Type. Please Wait...",
        type: 2,
      }),
    );
    return DomainGetAllService({ domain_type: "attendence_salary_type" })
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(GetAttendenceSalarytypeSuccessAction(response.data));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const GetAttendenceSalarytypeSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Get_Attendence_Salary_type_Success_Action,
    payload: data,
  };
};
// export const GetAllEmployeeWithPDFSuccessAction = (data: any) => {
//   return {
//     type: EmployeeActionTypes.GET_All_Employee_WITH_PDF,
//     payload: data,
//   };
// };

export const getAllEmployeeAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Get All Employee. Please Wait...",
        type: 2,
      }),
    );
    return GetAllEmployeeService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(
            GetAllEmployeeSuccessAction({
              list: response.data.list,
              count: response.data.total_count,
            }),
          );
          // if (isPdf) {
          //   dispatch(
          //     GetAllEmployeeWithPDFSuccessAction({
          //       list: response.data.list,
          //       count: response.data.total_count,
          //       pdfList: response.data.pdfList,
          //     })
          //   );
          // } else {
          //   dispatch(
          //     GetAllEmployeeSuccessAction({
          //       list: response.data.list,
          //       count: response.data.total_count,
          //     })
          //   );
          // }
          //// console.log("666", response.data.total_count);
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const GetAllEmployeeSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Get_All_Employee_Success_Action,
    payload: data,
  };
};

export const getActionStatusAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Get Action Status. Please Wait...",
        type: 2,
      }),
    );
    return CheckActionStatus(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(getActionStatusSuccessAction(response.data));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const getActionStatusSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Get_Action_Status_Success_Action,
    payload: data,
  };
};

export const getEmployeeAllDetailsAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Get Employee All Details. Please Wait...",
        type: 2,
      }),
    );
    return GetEmployeeAllDetailsService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(
            GetEmployeeAllDetailsSuccessAction({
              documents_details: response.data.documents_details,
              employeeDetails: response.data.employeeDetails,
              permanent_address: response.data.permanent_address,
              present_address: response.data.present_address,
              education_details: response.data.education_details,
              experience_details: response.data.experience_details,
              ProjectAssociationWithLevelName: response.data.ProjectAssociation,
              designation_name_with_details:
                response.data.designation_name_with_details,
              EmployeeAttendanceReport: response.data.EmployeeAttendanceReport,
              SalaryDetail: response.data.SalaryDetail,
              SalaryHistory: response.data.SalaryHistory,
              professional_details: response.data.professional_details,
              reporting_manager_details:
                response.data.reporting_manager_details,
            }),
          );
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const GetEmployeeAllDetailsSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Get_Employee_All_Details_Success_Action,
    payload: data,
  };
};

export const GetAllBankListAction = () => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Get All Bank. Please Wait...",
        type: 2,
      }),
    );
    return GetAllBankListService()
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(GetAllBankListActionSuccessAction(response.data));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const GetAllBankListActionSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Get_All_Bank_Success_Action,
    payload: data,
  };
};

export const EditCandidateAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Updating Candidate. Please Wait...",
        type: 2,
      }),
    );
    return CandidateEditService(payload.data)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          payload.navigateTo(-1);
          payload.enqueueSnackbar("Successfully Updated", {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
          dispatch(EditCandidateSuccessAction());
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const EditCandidateSuccessAction = () => {
  return {
    type: EmployeeActionTypes.Edit_Candidate_Success_Action,
  };
};

export const GetAllCandidateBulkUploadListAction = (
  page_index?: number,
  page_size?: number,
  sort_by?: string | null,
  sort_order?: "asc" | "desc" | null
) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Candidate Bulk Upload List. Please Wait...",
        type: 2,
      }),
    );
    return GetCandidateBulkCreateListService(page_index, page_size, sort_by, sort_order)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          const listData = response.data?.data || response.data;
          dispatch(CandidateBulkUploadListSuccessAction(listData));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const GetCandidateBulkCreateStatusAction = (
  uploadId: number | string,
  filename: string,
  enqueSnack: any
) => {
  return (dispatch: any) => {
    const FileDownload = require("js-file-download");
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Downloading file...",
        type: 2,
      })
    );
    return GetCandidateBulkCreateStatusService(uploadId)
      .then((response: any) => {
        FileDownload(response.data, filename);
        if (enqueSnack) {
          enqueSnack("File downloaded successfully", { variant: "success" });
        }
      })
      .catch((error: any) => {
        if (enqueSnack) {
          enqueSnack("Failed to download file", { variant: "error" });
        }
        dispatch(
          ApiCallErrorAction({
            errorCode: "",
            message: "Failed to download file",
          })
        );
      })
      .finally(() => {
        dispatch(StopLoadingAction());
      });
  };
};

export const CandidateBulkUploadListSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Candidate_Bulk_Upload_List_Success_Action,
    payload: data,
  };
};

export const getBulkUploadStatusAction =
  (page_index?: number, page_size?: number) => (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Bulk Upload Status Details Loading. Please Wait...",
        type: 2,
      }),
    );
    return GetCandidateBulkCreateListService(page_index, page_size)
      .then((response) => {
        if (response.status !== 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          const listData = response.data?.data || response.data;
          dispatch({
            type: EmployeeActionTypes.GET_BULK_UPLOAD_STATUS_ACTION,
            payload: listData,
          });
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };

export const getUpdatedBulkStatusAction =
  (bulkIds: number[]) => (dispatch: any, getState: any) => {
    return getBulkUploadCandidateUpdated(bulkIds)
      .then((response) => {
        if (response.status !== 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch({
            type: EmployeeActionTypes.GET_BULK_UPLOAD_STATUS_ACTION_UPDATED,
            payload: response.data,
          });
        }
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };

export const EditEmployeeDashboardAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Updating Employee Details. Please Wait...",
        type: 2,
      }),
    );
    return EmployeeEditService(payload.data)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          payload.enqueueSnackbar("Successfully Updated", {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
          dispatch(EditEmployeeDashboardSuccessAction());
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const EditEmployeeDashboardSuccessAction = () => {
  return {
    type: EmployeeActionTypes.Edit_Employee_Dashboard_Success_Action,
  };
};

export const resetpasswordrequestAction =
  (employee_id: string, enqueueSnackbar: any) =>
    (dispatch: any, getState: any) => {
      resetpasswordrequestService(employee_id)
        .then(async (response) => {
          if (response.status != 200) {
            dispatch(ApiCallErrorAction(response.data));
          } else {
            enqueueSnackbar("Password reset request successfully implemented", {
              variant: "success",
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
            });
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            let cook = new Cookies();
            dispatch(
              ApiCallErrorAction({
                errorCode: "",
                message: "Please Login again to continue.",
              }),
            );
            cook.remove("user", { path: "/" });
            dispatch(LogOutAction());
          } else if (error.response.status === 500) {
            dispatch(
              ApiCallErrorAction({
                errorCode: "",
                message: error?.response?.data?.message,
              }),
            );
          }
        });
    };

export const EmployeeTransferAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Transferring Employee. Please Wait...",
        type: 2,
      }),
    );
    return EmployeeTransferService(payload.data)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          payload.enqueueSnackbar(
            response.data?.message || "Employee transferred successfully.",
            {
              variant: "success",
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
            },
          );
          dispatch(EmployeeTransferSuccessAction());
          if (payload.onSuccess) {
            payload.onSuccess();
          }
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Something went wrong. Please try again.",
            }),
          );
        }
      });
  };
};

export const EmployeeTransferSuccessAction = () => {
  return {
    type: EmployeeActionTypes.Employee_Transfer_Success_Action,
  };
};

export const GetEmployeeTransferRequestsAction = (
  pageIndex?: number,
  pageSize?: number,
  filters?: {
    employee_id?: string | null;
    employee_name?: string | null;
    current_organization_id?: number | null;
    new_organization_id?: number | null;
    status?: number | null;
  },
  searchText?: string,
) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Fetching Transfer Requests. Please Wait...",
        type: 2,
      }),
    );
    return GetEmployeeTransferRequestsService(pageIndex, pageSize, filters, searchText)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch({
            type: EmployeeActionTypes.Get_Employee_Transfer_Requests_Success_Action,
            payload: response.data,
          });
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Something went wrong. Please try again.",
            }),
          );
        }
      });
  };
};

export const ReportingManagerEditAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Updating Reporting Manager Details. Please Wait...",
        type: 2,
      }),
    );
    return ReportingManagerEditService(payload.data)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          payload.enqueueSnackbar("Successfully Updated", {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
          dispatch(ReportingManagerEditSuccessAction());
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const ReportingManagerEditSuccessAction = () => {
  return {
    type: EmployeeActionTypes.Reporting_Manager_Success_Action,
  };
};

export const GetMyTeamListSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Get_My_Team_List_Success_Action,
    payload: data,
  };
};

export const GetMyTeamAction = (sort_by?: string | null, sort_order?: "asc" | "desc" | null) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Get My Team List. Please Wait...",
        type: 2,
      }),
    );
    return GetMyTeamService(sort_by, sort_order)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(GetMyTeamListSuccessAction(response.data));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const GetEmployeeLocationsSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Get_Employee_Locations_Success_Action,
    payload: data,
  };
};

export const GetEmployeeLocationsAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Get Employee Locations. Please Wait...",
        type: 2,
      }),
    );
    return GetEmployeeLocationsService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(GetEmployeeLocationsSuccessAction(response.data.data));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const CreateEmployeeLocationsSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Create_Employee_Locations_Success_Action,
    payload: data,
  };
};

export const CreateEmployeeLocationsAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Create Employee Locations. Please Wait...",
        type: 2,
      }),
    );
    return CreateEmployeeLocationService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(
            GetEmployeeLocationsAction({
              employee_id: payload.employee_id,
            }),
          );
          dispatch(CreateEmployeeLocationsSuccessAction(response.data));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const DeleteEmployeeLocationsSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Delete_Employee_Locations_Success_Action,
    payload: data,
  };
};

export const DeleteEmployeeLocationsAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Delete Employee Locations. Please Wait...",
        type: 2,
      }),
    );
    return DeleteEmployeeLocationService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(
            GetEmployeeLocationsAction({
              employee_id: payload.employee_id,
            }),
          );
          dispatch(DeleteEmployeeLocationsSuccessAction(response.data));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const AddEmployeeImagesSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Add_Employee_Images_Success_Action,
    payload: data,
  };
};

export const AddEmployeeImagesAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Add Employee Images. Please Wait...",
        type: 2,
      }),
    );
    return AddEmployeeImagesService(payload)
      .then(async (response) => {
        if (response?.status !== 200) {
          const errorMessage =
            response?.data?.message ||
            "Unable to upload the face image. Please try again.";
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: errorMessage,
            }),
          );
          throw new Error(errorMessage);
        }

        dispatch(AddEmployeeImagesSuccessAction(response.data));
        return response;
      })
      .catch((error) => {
        const status = error?.response?.status;

        if (status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message:
                error?.message || "Error encountered please try again later",
            }),
          );
        }

        throw error;
      });
  };
};

export const GetEmployeeImageSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Get_Employee_Images_Success_Action,
    payload: data,
  };
};

export const GetEmployeeImageAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(GetEmployeeImageSuccessAction([]));
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Get Employee Images. Please Wait...",
        type: 2,
      }),
    );
    return GetEmployeeImagesService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(GetEmployeeImageSuccessAction(response.data));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const DeleteEmployeeImagesSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Delete_Employee_Images_Success_Action,
    payload: data,
  };
};

export const DeleteEmployeeImagesAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Delete Employee Images. Please Wait...",
        type: 2,
      }),
    );
    return DeleteEmployeeImagesService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(
            GetEmployeeImageAction({
              employeeId: payload.employeeId,
            }),
          );
          dispatch(DeleteEmployeeImagesSuccessAction(response.data));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const GetMyDocumentSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Get_My_Document_Success_Action,
    payload: data,
  };
};

export const GetMyDocumentAction = (employeeId: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Get My Document List. Please Wait...",
        type: 2,
      }),
    );
    return GetMyDocumentService(employeeId)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(GetMyDocumentSuccessAction(response.data));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const DeleteMyDocumentSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Delete_My_Document_Success_Action,
    payload: data,
  };
};

export const DeleteMyDocumentAction = (id: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Delete My Document List. Please Wait...",
        type: 2,
      }),
    );
    return DeleteMyDocumentService(id)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(DeleteMyDocumentSuccessAction(response.data));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const ChangeReportingManagerSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Change_Reporting_Manager_Success_Action,
    payload: data,
  };
};

export const ChangeReportingManagerAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Change reporting manager. Please Wait...",
        type: 2,
      }),
    );
    return ChangeReportingManagerService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(ChangeReportingManagerSuccessAction(response.data));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};
export const UpdateSingleEmpSalaryAction = ({
  payload,
  successCallback,
}: {
  payload: any;
  successCallback?: any;
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Update Employee Single Salary. Please Wait...",
        type: 2,
      }),
    );
    return UpdateSingleEmpSalaryService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(UpdateSingleEmpSalarySuccessAction(response.data));
          successCallback?.();
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};
export const UpdateSingleEmpSalarySuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Update_Salary_Structure_Success_Action,
    payload: data,
  };
};
export const CalculateSingleEmpSalaryAction = ({
  payload,
  successCallback,
}: {
  payload: any;
  successCallback?: any;
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Calculate Employee Single Salary. Please Wait...",
        type: 2,
      }),
    );
    return CalculateSingleEmpSalaryService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(CalculateSingleEmpSalarySuccessAction(response.data));
          successCallback?.(response.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};
export const CalculateSingleEmpSalarySuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Calculate_Employee_Single_Salary_Success_Action,
    payload: data,
  };
};
export const CandidateListAgainstStatusAction = ({
  payload,
  successCallback,
}: {
  payload: CandidateListAgainstStatusPayload;
  successCallback?: any;
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Candidate List Against Status. Please Wait...",
        type: 2,
      }),
    );
    return CandidateListAgainstStatusService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(CandidateListAgainstStatusSuccessAction(response.data));
          successCallback?.(response.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};
export const CandidateListAgainstStatusSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Candidate_List_Against_Status_Success_Action,
    payload: data,
  };
};

export const SalaryGivenForWaitingCandidateAction = ({
  payload,
  successCallback,
}: {
  payload: SalaryDetailsGivenForWaitingCandPayload;
  successCallback?: any;
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Salry Given For Waiting Candidate. Please Wait...",
        type: 2,
      }),
    );
    return SalaryGivenForCandidateService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(SalaryGivenForWaitingCandidateSuccessAction(response.data));
          successCallback?.(response.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};
export const SalaryGivenForWaitingCandidateSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Salary_Given_For_Waiting_Candidate_Success_Action,
    payload: data,
  };
};

export const SendOfferMailToCandidateAction = ({
  payload,
  successCallback,
}: {
  payload: SendOfferMailToCandidatePayload;
  successCallback?: any;
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Send Offer Mail to Candidate. Please Wait...",
        type: 2,
      }),
    );
    return SendOfferMailToCandidateService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          successCallback?.(response.data);
          dispatch(SendOfferMailToCandidateSuccessAction(response.data));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};
export const SendOfferMailToCandidateSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Send_Official_Mail_To_Candidate_Success_Action,
    payload: data,
  };
};
export const GetSalaryDetailsForApprovalForCandidateAction = ({
  payload,
  successCallback,
}: {
  payload: GetSalaryDetailsForApprovalPayload;
  successCallback?: any;
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Get Salry Details For Candidate. Please Wait...",
        type: 2,
      }),
    );
    return GetSalaryDetailsForApprovalService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(
            GetSalaryDetailsForApprovalForCandidateSuccessAction(response.data),
          );
          successCallback?.(response.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};
export const GetSalaryDetailsForApprovalForCandidateSuccessAction = (
  data: any,
) => {
  return {
    type: EmployeeActionTypes.Get_Salary_Details_For_Candidate_Success_Action,
    payload: data,
  };
};

export const UserCreationFromOnboardingAction = ({
  payload,
  successCallback,
}: {
  payload: UserCreationFromOnbardongPayload;
  successCallback?: any;
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "User Creation Candidate. Please Wait...",
        type: 2,
      }),
    );
    return UserCreationFromOnboardingService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          successCallback?.(response.data);
          dispatch(UserCreationFromOnboardingSuccessAction(response.data));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};
export const UserCreationFromOnboardingSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.User_Creation_From_Onboarding_Candidate_Success_Action,
    payload: data,
  };
};

export const GetAllTermConditionsAction = (
  payload: any,
  successCallback?: any,
) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Get All Term Conditions. Please Wait...",
        type: 2,
      }),
    );
    return getAllTermConditionService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(GetAllTermConditionsSuccessAction(response.data));
          successCallback?.(response.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};
export const GetAllTermConditionsSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Get_All_Term_Conditions_Success_Action,
    payload: data,
  };
};

export const UpdateAttendancePlatformSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Update_Attendance_Platform_Success_Action,
    payload: data,
  };
};

export const UpdateAttendancePlatformAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Updating Attendance Platform. Please Wait...",
        type: 2,
      }),
    );
    return UpdateAttendancePlatformService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(UpdateAttendancePlatformSuccessAction(response.data));
          payload?.enqueueSnackbar?.("Attendance platform updated successfully.", {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
          payload?.onSuccess?.();
        }
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response?.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const UpdateAutoAttendanceSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Update_Auto_Attendance_Success_Action,
    payload: data,
  };
};

export const UpdateAutoAttendanceAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Updating Auto Attendance. Please Wait...",
        type: 2,
      }),
    );
    return UpdateAutoAttendanceService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(UpdateAutoAttendanceSuccessAction(response.data));
          payload?.enqueueSnackbar?.("Auto attendance updated successfully.", {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
          payload?.onSuccess?.();
        }
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response?.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const UpdateAttenFromAnyLocationSuccessAction = (data: any) => {
  return {
    type: EmployeeActionTypes.Update_Atten_From_Any_Location_Success_Action,
    payload: data,
  };
};

export const UpdateAttenFromAnyLocationAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Updating Any Geo Location. Please Wait...",
        type: 2,
      }),
    );
    return UpdateAttenFromAnyLocationService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(UpdateAttenFromAnyLocationSuccessAction(response.data));
          payload?.enqueueSnackbar?.("Any geo location updated successfully.", {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
          payload?.onSuccess?.();
        }
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response?.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
};

export const searchByNameEmpAction =
  (searchQuery: string, empType?: string) => (dispatch: any, getState: any) => {
    return searchNameService(searchQuery ? searchQuery : "", empType)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch({
            type: EmployeeActionTypes.Search_By_Name_Or_Id_Action,
            payload: response.data,
          });
        }
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            }),
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response?.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            }),
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            }),
          );
        }
      });
  };
